/* Cãomigo — movimento global (home, coleções, páginas): o traço âmbar de cada secção
   desenha-se da esquerda para a direita quando entra no ecrã, como uma linha de estrada.
   As páginas de produto novas (.cmg-pp) têm o seu próprio motor. O hero não anima. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;
  var d = document.documentElement;

  function init() {
    var rules = document.querySelectorAll('.cmg .rule, .cmgc .rule, .cmgpg .rule');
    if (!rules.length) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('cmg-drawn'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    var vh = window.innerHeight || 800;
    rules.forEach(function (r) {
      // o hero e o que já está à vista no primeiro ecrã ficam como estão (sem piscar)
      if (r.closest('.hero') || r.getBoundingClientRect().top < vh * 0.85) { r.classList.add('cmg-drawn'); return; }
      io.observe(r);
    });
    d.classList.add('cmg-mv');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
